import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import './index.css'
import UtilityNav from '../../../_components/common/UtilityNav';
import ModalComponent from '../../../_components/common/Modal';


// csv table and parsing tool
import * as Papa from 'papaparse';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css'

//validation
import { validation, cellValidation } from './validation';

//action
import { orgAdminAction } from '../../../_actions';


//modal
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';



class TeamMemberUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            orgId: 0,
            modal: false,
            chooseFile: false,
            navData: [],
            csvData: [],
            readOnlyCsv: false,
            csvButtonData: [],
            uploadDisability: false,
            validateDisability: false,
            validationText: 'VALIDATE',
            teamList: [],
            teamListOpt: [],

            //
            showCsvError: false,
            csvErrorData: []
        }
    }

    componentDidMount() {

        const {dispatch} = this.props;

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");

        let teamList = [];
        let teamListOpt = [];

        const compulateChildrenFunc = (data) => {
            data.map(val => {
                if(val.children.length !== 0) {
                    compulateChildrenFunc2(val.children)
                }
                teamList.push(val)
            })
        }
        const compulateChildrenFunc2 = (data) => {
            
            data.map(val => {
                if(val.children.length !== 0) {
                    compulateChildrenFunc(val.children)
                }
                teamList.push(val)
            })
        }

        dispatch(orgAdminAction.getOrgTeamHandler(orgIdFromPath, (data) => {
            let team_list = [...data.data.team_list]
            
            team_list.map(val => {
                if(val.children.length !== 0) {
                    compulateChildrenFunc(val.children)
                }
                teamList.push(val)
            })
            teamList.map(val => {
                teamListOpt.push(val.team_name)
            })
            this.setState({
                teamListOpt,
                teamList
            }, () => {
                // console.log('teamListteamList', this.state.teamList)
            })
        }))

        this.setState({
            teamList,
            orgId: parseInt(orgIdFromPath, 10),
            csvButtonData: [
                {
                    id: 1,
                    name: 'Choose File',
                    toggler: this.toggleChooseFileModal.bind(this),
                    togglerModal: this.state.chooseFile,
                    title:'Choose File',
                },
                {
                    id: 2,
                    name: 'Validate',
                    toggler: this.ValidateCsv.bind(this),
                    togglerModal: this.state.chooseFile,
                    title:'Validate',
                    disabled: this.state.validateDisability ? '' : 'disabled'
                },
                {
                    id: 3,
                    name: 'Upload',
                    toggler: this.uploadCsvFunc.bind(this),
                    togglerModal: this.state.chooseFile,
                    title:'Upload',
                    disabled: this.state.uploadDisability ? '' : 'disabled'                                    
                }
            ]
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if(prevState.validateDisability !== this.state.validateDisability) {
            let csvButtonData = [...this.state.csvButtonData]
                csvButtonData.map(val => {
                    if(val.title === 'Validate') {
                        if(this.state.validateDisability) {
                            val.disabled = ''
                        }else {
                            val.disabled = 'disabled'                            
                        }
                    }
                })
            this.setState({
                csvButtonData
            })
        }
        if(prevState.validationText !== this.state.validationText) {
            let csvButtonData = [...this.state.csvButtonData]
                csvButtonData.map(val => {
                    if(val.title === 'Validate') {
                        val.name = this.state.validationText
                    }
                })
            this.setState({
                csvButtonData
            })
        }
        if(prevState.uploadDisability !== this.state.uploadDisability) {
            let csvButtonData = [...this.state.csvButtonData]
                csvButtonData.map(val => {
                    if(val.title === 'Upload') {
                        if(this.state.uploadDisability) {
                            val.disabled = ''
                        }else {
                            val.disabled = 'disabled'                            
                        }
                    }
                })
            this.setState({
                csvButtonData
            })
        }

        
    }

    ValidateCsv = () => {
        this.setState({
            uploadDisability: false,
            validateDisability: !this.state.validateDisability,
            validationText: this.state.validationText === 'VALIDATE' ? 'VALIDATING...' : 'GETTING CSV READY TO EDIT...'
        }, () => {
            setTimeout(() => {
                if (this.state.validationText === 'VALIDATING...') {
                    if (this.state.csvData.length !== 0) {
                        let csvValidationState = true;
                        let csvError = {
                            column: '',
                            row: {},
                            element: ''
                        }
                        let csvArray = this.csvJSON(this.state.csvData)
                        
                        const checkIfProperTeamName = (elementData) => {
                            if(elementData.length !== 0) {
                                let isValidated = false
                                for (let k = 0; k < this.state.teamListOpt.length; k++) {
                                    const element = this.state.teamListOpt[k];
                                    if(element === elementData) {
                                        isValidated = true;
                                    }
                                }
                                return isValidated;
                            }else {
                                return false
                            }
                        }

                        let emptyArrId = []
                        for (let i = 0; i < csvArray.length; i++) {
                            const element = csvArray[i];
                            element.email = element.email.replace(/(\r\n\t|\n|\r\t)/gm,"");

                            if ((element.email === '' || element.email === undefined) && (element.team_name === '' || element.team_name === undefined)) {
                                emptyArrId.push(i)
                            } else if (validation.isEmailAddress(element.email) !== true || checkIfProperTeamName(element.team_name) !== true) {
                                csvValidationState = false
                                break;
                            }
                        }

                        for (let i = 0; i < emptyArrId.length; i++) {
                            const element = emptyArrId[i];
                            csvArray.splice(element - i, 1)
                        }
                        let arrayCsv = []
                        for (let i = 0; i < csvArray.length; i++) {
                            const element = csvArray[i];
                            if (i === 0) {
                                arrayCsv.push(Object.keys(element))
                            }
                            arrayCsv.push(Object.values(element))
                        }


                        let errorStringCSV = `CSV VALIDATION FAILED`;
                        

                        if (csvValidationState === false) {
                            // let toastId1 = toast['error'](errorStringCSV, {
                            //     position: toast.POSITION.BOTTOM_LEFT,
                            //     autoClose: 3000,
                            // });
                            this.setState({
                                readOnlyCsv: false,
                                uploadDisability: false,
                                validationText: 'VALIDATE'
                            })
                        } else if (csvValidationState === true) {
                            // let toastId1 = toast['info'](`CSV VALIDATED SUCCESSFULLY`, {
                            //     position: toast.POSITION.BOTTOM_LEFT,
                            //     autoClose: 1500,
                            // });

                            // toast.update(toastId1, {
                            //     render: `CSV VALIDATED SUCCESSFULLY`,
                            //     type: toast.TYPE.INFO,
                            //     className: 'styleToastSuccess'
                            // })
                            this.setState({
                                csvData: arrayCsv,
                                readOnlyCsv: true,
                                validationText: 'EDIT CSV',
                                uploadDisability: true,
                                validateDisability: false
                            })
                        }
                    }
                } else if (this.state.validationText === 'GETTING CSV READY TO EDIT...') {
                    this.setState({
                        readOnlyCsv: false,
                        uploadDisability: false,
                        validationText: 'VALIDATE'
                    })
                }
                this.setState({
                    validateDisability: !this.state.validateDisability,
                })
            }, 1300);
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    toggleChooseFileModal(showModal) {
        this.setState({
            chooseFile: true
        })
    }

    actionSelected(data) {

    }

    toggleEntireUploadModal(showModal) {
        this.setState({
            chooseFile: false
        })
    }

    getDataFunc(e) {
        let that = this;
        
        Papa.parse(e.target.files[0], {
            complete: function (results) {
                that.setState({
                    validateDisability: true,
                    readOnlyCsv: false,
                    validationText: 'VALIDATE',
                    uploadDisability: false,
                    chooseFile: false,
                    csvData: results.data,
                })
            }
        });
    }

    cellbeforechange = (c, s) => {
        this.state.csvData[c[0][0]][c[0][1]] = c[0][3]
    }

    hotAfterValidate = (isValid, value, row, prop, source) => {
        // console.log('postisValid', isValid, value, row, prop, source)
    }

    csvJSON(csv) {

        var lines = csv;

        var result = [];

        var headers = lines[0];

        for (var i = 1; i < lines.length; i++) {

            var obj = {};
            var currentline = lines[i];

            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);

        }

        //return result; //JavaScript object
        return result; //JSON
    }

    uploadCsvFunc = () => {

        const { dispatch } = this.props;

        let csvJson = this.csvJSON(this.state.csvData)
        let uploadingCsvData = [];

        // {
        //     "analytics_organisation_id":2
        //     "team_members":
        //     [
        //         {
        //         "email":"abc@gmail.com",
        //         "team_name":"Team1"
        //         },
        //         {
        //         "email":"padma@gmail.com",
        //         "team_name":"Team2"
        //         },
        //         {
        //         "email":"xyz@gmail.com",
        //         "team_name":"Team2"
        //         }
        //     ]
        // }

        for (let i = 0; i < csvJson.length; i++) {
            const element = csvJson[i];
            uploadingCsvData.push({
                email: element.email,
                team_name: element.team_name
            })
        }

        const UploadingData = {
            analytics_organisation_id: this.state.orgId,
            team_members: uploadingCsvData
        }



        dispatch(
            orgAdminAction.uploadCsvForMembers(UploadingData, (res) => {
                let csvErrorData = []

                res.data.errors.map(val => {
                    csvErrorData.push(val)
                })

                this.setState({
                    csvErrorData
                }, () => {
                    if(this.state.csvErrorData.length === 0) {
                        this.setState({
                            csvData: []
                        })
                    }
                })
                this.errorModalToggler()
            })
        )

    }


    errorModalToggler() {
        this.setState({
            showCsvError: !this.state.showCsvError
        })
    } 

    render() {
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">UPDATE TEAM MEMBERS</h5>

                        <UtilityNav
                            actionButtons={this.state.csvButtonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        <HotTable
                            data={this.state.csvData}
                            colHeaders={true}
                            rowHeaders={true}
                            ref="hot"
                            beforeChange={this.cellbeforechange}
                            // afterChange={(changes, source) => this.afterChange(changes, source)}
                            width="100%"
                            height="600"
                            stretchH="all"
                            readOnly={this.state.readOnlyCsv}
                            columns={[{
                                validator: cellValidation.isEmailAddress,
                                placeholder: 'Email address',
                                placeholderCellClassName: 'hot-placeholder',
                            },{
                                placeholder: 'Select Team Name',
                                placeholderCellClassName: 'hot-placeholder',
                                editor: 'select',
                                selectOptions: [...this.state.teamListOpt]
                            }]}
                            afterValidate={this.hotAfterValidate}
                            cells={(row, col, prop) => {
                                var cellProperties = {};

                                if (row === 0) {
                                    cellProperties.readOnly = true;
                                }

                                return cellProperties;
                            }}
                        />
                        {
                            this.state.chooseFile &&
                            <ModalComponent
                                showModal={this.state.chooseFile}
                                heading="CHOOSE FILE"
                                formData={[{
                                    key: 'chooseFile',
                                    type: 'file',
                                    accept: '.csv',
                                    value: '',
                                    valid: false,
                                    regex: ".+",
                                    elementConfig: {
                                        name: 'chooseFile',
                                        label: '',
                                        placeholder: 'Choose a file'
                                    },
                                    validation: {
                                        required: false,
                                        message: "is required"
                                    },
                                    getDataFunc: (data) => this.getDataFunc(data)
                                },]}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireUploadModal.bind(this)}
                                noClose={true}
                            />
                        }

                                <Modal isOpen={this.state.showCsvError} toggle={() => this.errorModalToggler()}>
                                    <ModalHeader toggle={() => this.errorModalToggler()} className="bg-black text-white text-uppercase custom-header">
                                        Upload Team Members
                                        </ModalHeader>
                                    <ModalBody>
                                        <div>
                                            {this.state.csvData.length === this.state.csvErrorData ? <h4 className="text-center text-danger">Upload failed</h4> : <h4 className="text-center text-success">Updated Successfully</h4>}
                                            <table style={{width: '100%'}}>
                                                <tbody>
                                                        {
                                                            this.state.csvErrorData.map(val => {
                                                                return (
                                                                <tr>                                                                    
                                                                    <td style={{padding: 10}}>{val.email}</td>
                                                                    <td style={{padding: 10}}>:</td>                                                                    
                                                                    <td style={{padding: 10}}>{val.message}</td>
                                                                </tr>                                                                    
                                                                )
                                                            })
                                                        }
                                                </tbody>
                                            </table>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={() => this.errorModalToggler()}>OK</Button>
                                    </ModalFooter>
                                </Modal>

                    </div>

                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {
        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(TeamMemberUpload);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/TeamMemberUpload.js